var _defs, _line, _line2, _path, _polyline, _line3, _polyline2, _line4, _polyline3, _line5, _polyline4, _line6, _path2, _path3, _polyline5, _line7, _polyline6, _line8, _g, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermeability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-width: .3px;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke-width: .25px;\n      }\n\n      .st2 {\n        fill: currentColor;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1.23,
    y1: 7.8,
    x2: 14.95,
    y2: 7.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1.23,
    y1: 9.62,
    x2: 14.95,
    y2: 9.62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.52.62c-.31.82-.99,1.37-.99,2.07,0,.79.57,1.07,1.01,1.07.47,0,.99-.34.99-1.02,0-.76-.66-1.31-1.01-2.13Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "2.87 6.39 3.53 7.04 4.18 6.39"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.53,
    y1: 4.84,
    x2: 3.53,
    y2: 7.04
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "2.87 11.27 3.53 11.92 4.18 11.27"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.53,
    y1: 10.48,
    x2: 3.53,
    y2: 11.91
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "7.43 11.27 8.09 11.92 8.75 11.27"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.09,
    y1: 10.48,
    x2: 8.09,
    y2: 11.91
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "7.43 6.39 8.09 7.04 8.75 6.39"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8.09,
    y1: 5.76,
    x2: 8.09,
    y2: 7.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.09,1.84c-.31.82-.99,1.37-.99,2.07,0,.79.57,1.07,1.01,1.07.47,0,.99-.34.99-1.02,0-.76-.66-1.31-1.01-2.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.65,1.23c-.31.82-.99,1.37-.99,2.07,0,.79.57,1.07,1.01,1.07.47,0,.99-.34.99-1.02,0-.76-.66-1.31-1.01-2.13Z"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12 11.27 12.66 11.92 13.32 11.27"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.66,
    y1: 10.48,
    x2: 12.66,
    y2: 11.91
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12 6.39 12.66 7.04 13.32 6.39"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.66,
    y1: 5.3,
    x2: 12.66,
    y2: 7.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 3.22,
    cy: 2.81,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 3.81,
    cy: 2.33,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 3.78,
    cy: 3.04,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 7.79,
    cy: 4.03,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8.38,
    cy: 3.55,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8.35,
    cy: 4.26,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.35,
    cy: 3.42,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.94,
    cy: 2.94,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.91,
    cy: 3.65,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1.76,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 3.34,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 4.93,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 6.51,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8.09,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 9.68,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 11.26,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.84,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 14.43,
    cy: 8.5,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 2.56,
    cy: 8.99,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 4.15,
    cy: 8.99,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 5.74,
    cy: 8.99,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 7.33,
    cy: 8.99,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8.92,
    cy: 8.99,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 10.51,
    cy: 8.99,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.09,
    cy: 8.99,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 13.68,
    cy: 8.99,
    r: 0.21
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.51,13.05c-.26.68-.83,1.14-.83,1.73,0,.66.48.9.84.9.4,0,.83-.28.83-.85,0-.64-.55-1.1-.84-1.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.07,13.05c-.26.68-.83,1.14-.83,1.73,0,.66.48.9.84.9.4,0,.83-.28.83-.85,0-.64-.55-1.1-.84-1.78Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.64,13.05c-.26.68-.83,1.14-.83,1.73,0,.66.48.9.84.9.4,0,.83-.28.83-.85,0-.64-.55-1.1-.84-1.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermeability);
export default __webpack_public_path__ + "static/media/permeability.2cb26ec0324319cabc0ac0a9955ba25f.svg";
export { ForwardRef as ReactComponent };